// src/pages/CategorySection.jsx

import React, { useState , useEffect, useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import CategoryCard from '../../../../components/user/home/categorycard/CategoryCard.js';
import '../../../../assets/css/user/home/subscreens/categorysection/CategorySection.css';
import axios from "axios";
import AppContext from '../../../../context/AppContext.js';

// ── Images ──
import tractorImg     from '../../../../assets/images/home/tractor.jpg';
import harvestorImg   from '../../../../assets/images/home/harvestor.jpg';
import seeddrillImg   from '../../../../assets/images/home/seeddrill.png';
import rotavatorImg   from '../../../../assets/images/home/rotavator.jpg';
import seedplanterImg from '../../../../assets/images/home/seedplanter.jpg';
import cultivatorImg  from '../../../../assets/images/home/cultivator.jpg';
import irrigationImg  from '../../../../assets/images/home/irrigation.jpg';
import thresherImg    from '../../../../assets/images/home/thresher.jpg';
import ploughImg      from '../../../../assets/images/home/plough.jpg';
import balerImg       from '../../../../assets/images/home/baler.jpg';
import pumpImg        from '../../../../assets/images/home/pump.jpg';
import trolleyImg     from '../../../../assets/images/home/trolley.jpg';
import laserImg       from '../../../../assets/images/home/laser.jpg';
import discharrowImg  from '../../../../assets/images/home/discharrow.jpg';

const CARDS_PER_PAGE = 3;

const CategorySection = () => {
  const navigate  = useNavigate();
  const [page, setPage] = useState(0);
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [categoriesData, setCategoriesData] = useState([]);

    const fetchAllCategories = () => {
    axios.get(`${baseUrl}/customer/categories/fetchAllCategories`)
      .then((response) => {
        console.log(response.data);
        if(response.data.success == true){
          setCategoriesData(response.data.categories);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    console.log("log from the category data");
    fetchAllCategories();
  }, []);


  // const categories = [
  //   { id: 1,  name: 'Tractors',    image: tractorImg     },
  //   { id: 2,  name: 'Harvesters',  image: harvestorImg   },
  //   { id: 3,  name: 'Seeders',     image: seeddrillImg   },
  //   { id: 4,  name: 'Tillers',     image: rotavatorImg   },
  //   { id: 5,  name: 'Planters',    image: seedplanterImg },
  //   { id: 6,  name: 'Cultivators', image: cultivatorImg  },
  //   { id: 7,  name: 'Irrigation',  image: irrigationImg  },
  //   { id: 8,  name: 'Threshers',   image: thresherImg    },
  //   { id: 9,  name: 'Ploughs',     image: ploughImg      },
  //   { id: 10, name: 'Balers',      image: balerImg       },
  //   { id: 11, name: 'Pumps',       image: pumpImg        },
  //   { id: 12, name: 'Trailers',    image: trolleyImg     },
  //   { id: 13, name: 'Levelers',    image: laserImg       },
  //   { id: 14, name: 'Harrows',     image: discharrowImg  },
  // ];

  const totalPages = Math.ceil(categoriesData.length / CARDS_PER_PAGE);
  const visibleCategories = categoriesData.slice(
    page * CARDS_PER_PAGE,
    page * CARDS_PER_PAGE + CARDS_PER_PAGE
  );

  const handleCategoryClick = (categoryName) => {
    navigate('/equipments', { state: { selectedCategory: categoryName } });
  };

  const handleShowMore = () => {
    navigate('/equipments', { state: { selectedCategory: 'All Products' } });
  };

  return (
    <section className="category-section">
      <div className="container">

        {/* Header */}
        <div className="category-header category-header-flex">
          <div>
            <h2 className="category-title">CATEGORIES</h2>
            <div className="title-underline"></div>
          </div>
          {/* <button className="show-more-btn1" onClick={handleShowMore}>
            Show More <span className="arrow">→</span>
          </button> */}
        </div>

        {/* Cards + Arrows */}
        <div className="category-slider-wrapper">

          {/* Prev Arrow */}
          <button
            className="cat-arrow cat-arrow-prev"
            onClick={() => setPage(p => Math.max(p - 1, 0))}
            disabled={page === 0}
          >
            ‹
          </button>

          {/* Cards */}
          <div className="category-cards-container">
            {visibleCategories.map((category) => (
              <CategoryCard
                key={category.id}
                category={category}
                onClick={() => handleCategoryClick(category.name)}
              />
            ))}
          </div>

          {/* Next Arrow */}
          <button
            className="cat-arrow cat-arrow-next"
            onClick={() => setPage(p => Math.min(p + 1, totalPages - 1))}
            disabled={page === totalPages - 1}
          >
            ›
          </button>

        </div>

        {/* Dots */}
        <div className="cat-dots">
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              className={`cat-dot ${i === page ? 'active' : ''}`}
              onClick={() => setPage(i)}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default CategorySection;